export default __webpack_public_path__ + "static/10-d6ce053a5b356da216310931153a9e7b.png";